import React, { useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../App.css';

const ForgotPassword = () => {

    const [email, setEmail] = useState('');

    const [loading, setLoading] = useState(false); // <--- YE LINE MISSING THI

    const navigate = useNavigate();



    const handleForgot = async (e) => {

        e.preventDefault();

        setLoading(true); // Ab error nahi aayega



        try {

            // Backend check karega email sahi hai ya nahi

            const response = await API.post(`/forgot-password?email=${email}`);

           

            localStorage.setItem('userEmail', email);

            toast.success(response.data.message);

           

            // Success hone par hi redirect hoga

            navigate('/reset-password');

           

        } catch (error) {

            const errorMsg = error.response?.data?.detail || "Something went wrong";

            toast.error(errorMsg);

        } finally {

            setLoading(false); // Process khatam hone par loading band

        }

    };



    return (

        <div className="main-bg">

            <div className="brand-section">

                <h1>Cortex</h1>

                <p>Lost your way?<br/>Let's get your account back on track.</p>

            </div>

            <div className="auth-container">

                <h2>Recovery</h2>

                <p className="sub-text" style={{ color: 'white', marginBottom: '29px', opacity: '0.9' }}>

    Enter email to receive reset code

</p>

                <form onSubmit={handleForgot}>

                    <input

                        type="email"

                        placeholder="Email Address"

                        value={email}

                        onChange={(e) => setEmail(e.target.value)}

                        required

                    />

                    {/* Button ko disable kardein jab tak processing ho rahi ho */}

                    <button type="submit" disabled={loading}>

                        {loading ? <span className="spinner"></span> : "Send Reset Code"}

                    </button>

                </form>

                <p style={{marginTop: '20px'}}>

                    <span className="white-link" onClick={() => navigate('/login')}>Back to Login</span>

                </p>

            </div>

        </div>

    );

};



export default ForgotPassword;